import errorManager from '@/rollbar.js';

const handleButton = (usernameSelector, buttonSelector) => {
  const buttonSubmit = document.getElementById(buttonSelector);
  const username = document.getElementById(usernameSelector);
  const emailRegex = new RegExp(window.config.email_regex_ldap);
  username.addEventListener('keyup', (event) => {
    if (emailRegex.test(event.currentTarget.value)) {
      buttonSubmit.value = 'Utente non abilitato per modifica password';
      buttonSubmit.classList.add('disabled');
      buttonSubmit.disabled = true;
    } else {
      buttonSubmit.value = 'Inviami le istruzioni per resettare la password';
      buttonSubmit.classList.remove('disabled');
      buttonSubmit.disabled = false;
    }
  });
};

const init = (usernameSelector, buttonSelector) => {
  try {
    handleButton(usernameSelector, buttonSelector);
  } catch (e) {
    errorManager(e);
  }
};

window.LdapUsernameValidation = {
  init: init,
};
